import React from 'react';
import styles from './SchedulerTableCells.module.css';

const AssessorName: React.FC<{
  isChildRow?: boolean;
  hasAssessor: boolean;
  assessorName?: string;
}> = ({ isChildRow, hasAssessor, assessorName }) => {
  if (isChildRow) {
    return <span className={styles.emptyCell}>—</span>;
  }

  if (hasAssessor && assessorName) {
    return <>{assessorName}</>;
  }

  return <span className={styles.noDate}>Not Assigned</span>;
};

export default AssessorName;
